// Title-cases a name for display - "ARVIND SHIBARGATTI" / "arvind shibargatti"
// -> "Arvind Shibargatti". Capitalizes the first letter after every word
// boundary (so hyphenated/multi-word names work too), lowercases the rest.
export function toTitleCase(value) {
  if (!value) return value
  return String(value)
    .toLowerCase()
    .replace(/\b\p{L}/gu, (ch) => ch.toUpperCase())
}
